<section class="key-benefits-section orange">
  <p class="title">¿Por qué estudiar en Campus del Saber?</p>
  <div class="container">
    <div class="cards" #cardsAnimation>
      <div>
        <h3>Beca 100%</h3>
        <p>Estudia en una universidad privada con becas cubiertas al 100% durante toda la formación profesional.</p>
      </div>
      <div>
        <h3>Trabajo asegurado</h3>
        <p>Cuando finalices tus estudios, tendrás un puesto de trabajo remunerado en la industria de tecnología.</p>
      </div>
      <div>
        <h3>Educación Bilingüe</h3>
        <p>Obtendrás el nivel necesario de inglés para desenvolverte con fluidez en un entorno laboral mundial.</p>
      </div>
    </div>
  </div>
  <a href="{{ formGenericUrl }}" target="_blank">
    <img class="redirect" [src]="studyWithUsButtonPath" alt="sutdy with us button" />
  </a>
</section>
